/* eslint-disable */
export default {
  region: '地区',
  calling: '呼叫',
  logout: '退出登录',
  version: '版本',
  settings: '设置',
  selectToDialSMS: '选择以拨号发送短信',
  selectToDial: '选择以拨号',
  selectToSMS: '选择以发送短信',
  clickToDial: '点击拨号',
  autoCreateLog: '自动创建通话记录',
  autoCreateSMSLog: '自动创建短信记录',
  autoLogCalls: '自动记录通话',
  autoLogNotes: '自动记录笔记',
  autoLogSMS: '自动记录短信',
  clickToSMS: '点击发短信',
  logSMSContent: '记录短信内容',
  clickToDialSMS: '点击打电话/发短信',
  logExtensionCall: '记录分机通话',
  audio: '音频',
  language: '语言',
  feedback: '反馈',
  userGuide: '新功能',
  quickAccess: '快速访问设置',
  report: '分析报告',
  shareIdea: '分享想法',
  openEntityFrom: 'Salesforce 对象行为',
  ctiPanelSize: 'CTI 面板大小',
  openInNewTab: '在新选项卡中打开',
  openInCurrentTab: '在当前选项卡中打开',
  reportIssue: '报告问题',
  contactSupport: '联系支持人员',
  selectToDialHint:
    '为了获得更好的体验，请在大量电话号码页选择要使用 RingCentral 拨打的电话号码。',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
